import {fetchWithToken} from 'src/shared/api';
import {AUTH} from 'src/shared/auth/actions';
import {READ_DATACAST_COMPLETE} from 'src/shared/datacast/actions';
import {watchTowerSegment} from 'src/shared/datacast/constants';
import {hasWatchTowerSegment} from 'src/shared/datacast/selectors';
import {waitUntil} from 'src/shared/events';
import {LOAD_USER_SUCCESS} from 'src/shared/user/actions';
import {errorToJSON} from 'src/shared/utils/errorToJSON';

export const LOAD_WATCHTOWER_START = 'LOAD_WATCHTOWER_START';
export const LOAD_WATCHTOWER_COMPLETE = 'LOAD_WATCHTOWER_COMPLETE';
export const LOAD_WATCHTOWER_SUCCESS = 'LOAD_WATCHTOWER_SUCCESS';
export const LOAD_WATCHTOWER_ERROR = 'LOAD_WATCHTOWER_ERROR';

export const loadWatchtowerStart = () => ({
  type: LOAD_WATCHTOWER_START,
});

export const loadWatchtowerSuccess = watchtower => ({
  type: LOAD_WATCHTOWER_SUCCESS,
  value: {watchtower},
});

export const loadWatchtowerError = error => ({
  type: LOAD_WATCHTOWER_ERROR,
  value: {error: errorToJSON(error)},
});

export const loadWatchtowerComplete = () => ({
  type: LOAD_WATCHTOWER_COMPLETE,
});

const makeFetchOptions = opts =>
  Object.assign({}, opts, {
    headers: Object.assign({
      Client: 'dotcom_support',
    }, opts && opts.headers),
  });

const fetch = (state, options = {}) => {
  const {
    config: {urls: {watchTower}},
    user: {accountNumber},
    auth: {token},
  } = state;
  const url = watchTower.replace('/me', `/${accountNumber}`);
  return fetchWithToken(url, token, makeFetchOptions(options));
};

export const loadWatchtower = () => async (dispatch, getState) => {
  dispatch(loadWatchtowerStart());
  await waitUntil([
    AUTH,
    LOAD_USER_SUCCESS,
    READ_DATACAST_COMPLETE,
  ]);
  try {
    if (!hasWatchTowerSegment(getState())) {
      throw new Error(`The ${watchTowerSegment} segment does not exist.`);
    }
    const response = await fetch(getState());
    if (response.ok) {
      dispatch(loadWatchtowerSuccess((await response.json()).nearNeighbourDeviceOffline));
    } else {
      dispatch(loadWatchtowerError(new Error(response.status)));
    }
  } catch (error) {
    dispatch(loadWatchtowerError(error));
  } finally {
    dispatch(loadWatchtowerComplete());
  }
};
